import { ReactNode } from 'react';

export enum EUISnackBarVariant {
  BASIC = 'BASIC'
}

export enum EUISnackBarMessageType {
  SUCCESS = 'SUCCESS',
  IMPORTANT = 'IMPORTANT',
  ERROR = 'ERROR'
}

export interface IUISnackBarBaseProps {
  actionLabel?: string;
  children?: ReactNode;
  dataTestId?: string;
  delay?: number;
  fullOverlay?: boolean;
  zIndex?: number;
  onAction?: () => void;
  onClose?: () => void;
}

export interface IUIBasicSnackBarProps extends Omit<IUISnackBarBaseProps, 'variant' | 'children'> {
  id?: string;
  message: string;
  messageType: EUISnackBarMessageType;
  variant?: EUISnackBarVariant.BASIC;
  fullOverlay?: boolean;
  description?: string;
}

// To have mobile snackbar props in future
export type ISnackbarHandlerProps = IUIBasicSnackBarProps;

export interface ISnackbarHandler {
  alert: (params: ISnackbarHandlerProps) => void;
  close: (id: string) => void;
}
